import { cn } from 'lib/helpers/utility';

import Icon from 'components/shared/Icon/Icon';

const SIZES = {
  small: 120,
  medium: 200,
  large: 280
};

const DrAvatar = ({ size = 'medium', variant = 1, className }) => {
  const iconName =
    variant === 1 ? 'illustration-dr-clearcare' : `illustration-dr-clearcare-${variant}`;

  return (
    <div className={cn('relative shrink-0', className)}>
      <Icon icon={iconName} size={SIZES[size]} />
    </div>
  );
};

export default DrAvatar;
